import { AxiosError } from 'axios';
import { MutationCache, QueryCache, QueryClientConfig } from 'react-query';
import { handleError } from 'utils/apiUtils';

export const queryClientConfig: QueryClientConfig = {
  // Query(GET)에 대한 전역 에러 핸들링
  queryCache: new QueryCache({
    onError: (error: any) => handleError(error),
  }),

  // Mutation(POST/PUT/DELETE)에 대한 전역 에러 핸들링
  mutationCache: new MutationCache({
    onError: (error: any) => {
      handleError(error);
    },
  }),
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: (failureCount, error: AxiosError) => {
        if (error?.status >= 400 && error?.status < 500) return false;
        return failureCount < 3;
      },
    },
  },
};
